module.exports = __webpack_public_path__ + "assets/img/07.8fbb1333.png";